"use client";

import type { StoreApi, UseBoundStore } from "zustand";

/**
 * Wraps a Zustand store and adds `.use.<key>()` selector hooks.
 *
 * Example:
 *   const store = createSelectors(useBoundStore);
 *   const baseline = store.use.baseline();
 */
export function createSelectors<S extends object>(
  store: UseBoundStore<StoreApi<S>>
) {
  const typedStore = store as UseBoundStore<StoreApi<S>> & {
    use: { [K in keyof S]: () => S[K] };
  };
  const selectors = {} as { [K in keyof S]: () => S[K] };

  for (const key of Object.keys(store.getState()) as (keyof S)[]) {
    selectors[key] = () => store((s) => s[key]);
  }
  typedStore.use = selectors;

  return typedStore;
}
